import React from 'react';
import styled from 'styled-components';

const EmptyStateContainer = styled.div`
  padding: var(--cc_size_spacing_s);
  text-align: center;
  font-size: var(--cc_size_text_s);
  color: var(--cc_color_text_subtle);
`;

type EmptyStateProps = {
  message: string;
};
const EmptyState = ({ message }: EmptyStateProps) => {
  return <EmptyStateContainer>{message}</EmptyStateContainer>;
};

export default EmptyState;
